module.exports = __webpack_public_path__ + "img/share_top3_bg.9f5d1584.webp";